<div class="d-flex justify-content-between mb-2 px-2">
	<h2>{{'nav.device_replacement_log' | translate}}</h2>
</div>
<sct-custom-table
	*ngIf="tableData.length;else noData"
	[columnsConfig]="tableColumns"
	[data]="tableData"
	[config]="tableConfig"
></sct-custom-table>

<ng-template #noData>
	<div class="mt-4 alert alert-info">{{'g.no_data_available' | translate}}</div>
</ng-template>